export default __webpack_public_path__ + "static/media/crew-10-bit.95ab1731.svg";